import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL; // Adjust the base URL as needed

const HospitalDetail = () => {
  const { hospitalId } = useParams();
  const [hospital, setHospital] = useState(null);

  useEffect(() => {
    // Fetch hospital details by ID
    axios
      .get(`${BASE_URL}/api/hospitals/${hospitalId}`)
      .then((response) => {
        setHospital(response.data.hospital);
      })
      .catch((error) => {
        console.error('Error fetching hospital details:', error);
      });
  }, [hospitalId]);

  if (!hospital) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <h2>{hospital.name}</h2>
      <p>Address: {hospital.address}</p>
      <p>Contact Info: {hospital.contact_info}</p>
      <h3>Admins</h3>
      <ul>
        {hospital.admins.map((admin) => (
          <li key={admin.id}>
            {admin.name} ({admin.email})
          </li>
        ))}
      </ul>
    </div>
  );
};

export default HospitalDetail;
